import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';
import { ProfileContext } from '../../profile';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface InputProps extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

const sanitizedValue = (input: string): string => {
  if (!input.length) {
    return null;
  }

  return input;
};

type Props = {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
};

export default function CompanySelectField(props: Props) {
  const { profile } = React.useContext(ProfileContext);

  return (
    <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
      <select
        {...props}
        id={props.id}
        onChange={(e) =>
          props.onValueChange(props.field, sanitizedValue(e.target.value))
        }
        className={theme.form.field.input}
      >
        {!profile.company_id ? (
          <option value={''}>Not a member</option>
        ) : (
          <React.Fragment>
            <option value={''}>Please Select</option>(
            <option value={profile.company.id}>{profile.company.name}</option>
          </React.Fragment>
        )}
      </select>
    </BaseForm>
  );
}
